import { render, staticRenderFns } from "./EmployeeContactReferences.vue?vue&type=template&id=22ae5936"
import script from "./EmployeeContactReferences.vue?vue&type=script&lang=js"
export * from "./EmployeeContactReferences.vue?vue&type=script&lang=js"
import style0 from "./EmployeeContactReferences.vue?vue&type=style&index=0&id=22ae5936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports